import { Component, Input } from '@angular/core';
import { ComponentWithCopy } from '../../intefaces/interfaces';
import { Link } from '../../components/link/link';
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large';
import { BodyLarge } from '../../components/typography/body-large/body-large';
import { AnimateOnScroll } from 'primeng/animateonscroll'

@Component({
  selector: 'app-feature-timeline',
  imports: [Link, HeadlineLarge, BodyLarge, AnimateOnScroll],
  templateUrl: './feature-timeline.html',
  styleUrl: './feature-timeline.css'
})
export class FeatureTimeline {
  @Input() content!: ComponentWithCopy

}
